import { render, staticRenderFns } from "./BusinessFacets.vue?vue&type=template&id=6feae2f6"
import script from "./BusinessFacets.vue?vue&type=script&lang=js"
export * from "./BusinessFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports